import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { awbHistoryModel } from 'src/app/models/awb-history.model';

@Component({
  standalone: false,
  selector: 'app-awb-history-modal',
  templateUrl: './awb-history-modal.component.html',
  styleUrls: ['./awb-history-modal.component.scss'],
})
export class AwbHistoryModalComponent {
  @Input() awbHistory: awbHistoryModel[] = [];
  @Input() shipping: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  iconAwb(value: string): string {
    let result = '';
    if (value === 'Pickup' || value === 'Created') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-pickup.svg';
    } else if (value === 'Process' || value === 'Sent') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-kirim.svg';
    } else if (value === 'Problem') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-problem.svg';
    } else if (value === 'Delivered' || value === 'Completed' || value === 'Received') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-terima.svg';
    } else if (value === 'Return' || value === 'Retur' || value === 'Return Done' || value === 'Canceled') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-retur.svg';
    } else if (value === 'Delivery' || value === 'Packed') {
      result =
        'https://storage.googleapis.com/komerce/assets/icons/resi-delivery.svg';
    }
    return result;
  }
}
